<template>
  <div class="park_list_com">
    <!-- 园区列表 -->
    <div class="gardenList_box">
      <ul v-if="list.length">
        <template v-for="item in list">
          <park_item :key="item.id" :itemObj="item" />
        </template>
      </ul>
      <div class="no_data" v-else>
        <img src="@/assets/img/common/no_data.png" alt />
        <p>没有园区信息~</p>
      </div>
    </div>
    
  </div>
</template>

<script>
import park_item from "@/components/park/park_item.vue";
export default {
  components: {
    park_item
  },
  props:{
    list:{
      type:Array
    }
  },
};
</script>

<style lang="scss" scoped>
.park_list_com {
  .gardenList_box {
    width: 100%;
    ul {
      display: flex;
      flex-wrap: wrap;
      
    }
    .no_data {
      text-align: center;
      padding: 40px 0;
      p {
        color: #a4a8ba;
        font-size: 14px;
      }
    }
  }
}
</style>